/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Recipients_No_RecipientsInputs */

const en_event_recipients_no_recipients = /** @type {(inputs: Event_Recipients_No_RecipientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Recipient(s) Assigned`)
};

const fr_event_recipients_no_recipients = /** @type {(inputs: Event_Recipients_No_RecipientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun destinataire assigne`)
};

const de_event_recipients_no_recipients = /** @type {(inputs: Event_Recipients_No_RecipientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein(e) Empfänger zugewiesen`)
};

const it_event_recipients_no_recipients = /** @type {(inputs: Event_Recipients_No_RecipientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun destinatario assegnato`)
};

const ru_event_recipients_no_recipients = /** @type {(inputs: Event_Recipients_No_RecipientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получатель(и) не назначен(ы)`)
};

const es_event_recipients_no_recipients = /** @type {(inputs: Event_Recipients_No_RecipientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay destinatario(s) asignado(s)`)
};

const zh_cn2_event_recipients_no_recipients = /** @type {(inputs: Event_Recipients_No_RecipientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未指定收件人`)
};

const ja_event_recipients_no_recipients = /** @type {(inputs: Event_Recipients_No_RecipientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受信者が割り当てられていません`)
};

const hi_event_recipients_no_recipients = /** @type {(inputs: Event_Recipients_No_RecipientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई प्राप्तकर्ता निर्धारित नहीं किया गया है`)
};

const pt_pt2_event_recipients_no_recipients = /** @type {(inputs: Event_Recipients_No_RecipientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum destinatário atribuído`)
};

/**
* | output |
* | --- |
* | "No Recipient(s) Assigned" |
*
* @param {Event_Recipients_No_RecipientsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_recipients_no_recipients = /** @type {((inputs?: Event_Recipients_No_RecipientsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Recipients_No_RecipientsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_recipients_no_recipients(inputs)
	if (locale === "de") return de_event_recipients_no_recipients(inputs)
	if (locale === "it") return it_event_recipients_no_recipients(inputs)
	if (locale === "ru") return ru_event_recipients_no_recipients(inputs)
	if (locale === "es") return es_event_recipients_no_recipients(inputs)
	if (locale === "zh-CN") return zh_cn2_event_recipients_no_recipients(inputs)
	if (locale === "ja") return ja_event_recipients_no_recipients(inputs)
	if (locale === "hi") return hi_event_recipients_no_recipients(inputs)
	if (locale === "pt-PT") return pt_pt2_event_recipients_no_recipients(inputs)
	return en_event_recipients_no_recipients(inputs)
});